export function trimText(value: string, limit: number): string {
  return value.length > limit ? value.substring(0, limit) + "..." : value;
}
